<template>
      <v-select
        hide-details 
        append-icon="search"
        label="Ana Tip"

        :loading="loading"
        :items="items"
        
        item-text="Aciklama"
        cache-items=""
        item-value="Kod"
        v-model="Kod"

      ></v-select>
</template>

<script>

export default {
    props:["value"],
      
    computed: {
      Kod: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue )
        },
      },
    },
  
    
    data () {
      return {
        loading: false,
        items: [
            {Kod:1, Aciklama:"Ic Tur"},
            {Kod:2, Aciklama:"Incoming"},
            {Kod:3, Aciklama:"Outgoing"},
            {Kod:4, Aciklama:"Toplanti Seminer"},
            {Kod:5, Aciklama:"Gemi"},
            {Kod:6, Aciklama:"Diger Hizmetler"},
            {Kod:7, Aciklama:"Yurt İçi"},
            {Kod:8, Aciklama:"Yurt Dışı"},
            {Kod:9, Aciklama:"Kıbrıs"},
            {Kod:10, Aciklama:"Etkinlik"},
            {Kod:11, Aciklama:"Kara Turları"},
        ],
      }
    },
  
  watch: {
    
  },
  methods: {

  }
}


</script>